module.exports = __webpack_public_path__ + "img/khjl-tx@2x.f628fc6b.png";